import React from 'react';
import './SignupPage.css';
import MainScreenV1 from '../components/MainScreen/MainScreenV1';

const SignupPage = () => {
  return (
    <div>
      <MainScreenV1 />
    </div>
  );
};

export default SignupPage;
